import { createSlice } from '@reduxjs/toolkit';
import DataExportsAPI from '~/api/data-exports-api';
import DataExportStatusConstants from '~/constants/data-export-status-constants';
import createCaughtAsyncThunk from '~/utils/create-action/create-caught-async-thunk';
import { defaultState } from '../../data/DataExportCardState';
import { createExportHistoryEntry } from '../../data/ExportHistoryEntry';
import { addDataExportCasesToBuilder } from '../../reducer-utils';

export const exportMachinesAndInventoryData = createCaughtAsyncThunk(
  'exportMachinesAndInventoryData',
  async () => {
    return DataExportsAPI.exportMachinesAndInventory();
  }
);

export const getMachinesAndInventoryExportStatus = createCaughtAsyncThunk<
  any,
  string
>('getMachinesAndInventoryExportStatus', async (id, thunkAPI) => {
  const response = await DataExportsAPI.getExportStatus(id);
  if (response.status === DataExportStatusConstants.CREATED) {
    thunkAPI.dispatch(setExportHistory([response]));
  }
  return response;
});

const slice = createSlice({
  name: 'data-exports-inventory',
  initialState: defaultState,
  reducers: {
    setExportHistory: (state, action) => {
      state.exportHistory = action.payload.map(createExportHistoryEntry);
    },
  },
  extraReducers: (builder) => {
    addDataExportCasesToBuilder(
      builder,
      'machinesAndInventory',
      exportMachinesAndInventoryData,
      getMachinesAndInventoryExportStatus
    );
  },
});

export const { setExportHistory } = slice.actions;
export default slice.reducer;
